import { render } from "./ProfileLayoutClean.vue?vue&type=template&id=c496df42&scoped=true"
import script from "./ProfileLayoutClean.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutClean.vue?vue&type=script&lang=js"

import "./ProfileLayoutClean.vue?vue&type=style&index=0&id=c496df42&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c496df42"]])

export default __exports__